import React from 'react';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { ReservationCompletePane } from '../../molecules/reservations/ReservationCompletePane';
import { SessionReservationCompletePaneState } from './states/SessionReservationCompletePaneState';

type Props = {
  match: {
    url: string;
    params: {
      sessionId: string;
    };
  };
};

export const SessionReservationCompletePane = observer(
  class SessionReservationCompletePane extends React.Component<Props> {
    paneState = new SessionReservationCompletePaneState();

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        paneState: observable,
      });
    }

    componentDidMount(): void {
      this.init();
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
      if (this.props.match.params.sessionId !== prevProps.match.params.sessionId) {
        this.init();
      }
    }

    init() {
      this.paneState.init(Number(this.props.match.params.sessionId));
    }

    render() {
      const { session: sessionResource } = this.paneState;
      if (sessionResource.loading) {
        return <GlobalLoader />;
      }
      if (sessionResource.isNotFound()) {
        return <NotFoundPage />;
      }
      const session = sessionResource.get();
      return <ReservationCompletePane reservable={session} />;
    }
  }
);
